import styled from 'styled-components';

export const RecommendedCoursesContainer = styled.section`
  /* width: 100%; */
  /* margin: var(--space-xxl) auto 0; */
  /* padding: var(--space-xxl) 0; */
  display: flex;
  flex-direction: column;
  gap: var(--space-m);
`;
export const RecommendedCoursesHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-m);
  margin-bottom: var(--space-l);

  h3 {
    margin: 0;
    color: var(--grey7);
    font-size: clamp(1.2rem, 2vw, 1.55rem);
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.02em;
    border: none;
  }
  p {
    max-width: 520px;
    margin: 0.35rem 0 0;
    color: var(--grey5);
    font-size: 0.96rem;
    font-weight: 500;
    line-height: 1.6;
  }
  @media (max-width: 700px) {
    align-items: flex-start;
    h3 {
      font-size: 1.15rem;
    }

    p {
      font-size: 0.92rem;
    }
  }
`;

export const RecommendedCoursesScroller = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(260px, 1fr);
  gap: var(--space-m);
  overflow-x: auto;
  overscroll-behavior-inline: contain;
  padding: 0 0 var(--space-s);
  scroll-snap-type: inline mandatory;
  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: var(--grey1);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--grey2);
    border-radius: 999px;
  }

  @media (min-width: 1100px) {
    grid-auto-columns: minmax(250px, 1fr);
  }
`;

export const EachRecommendedCourse = styled.article`
  scroll-snap-align: start;

  min-width: 0;

  background: var(--white);
  border: 1px solid var(--grey1);
  border-radius: 18px;

  overflow: hidden;

  cursor: pointer;

  box-shadow:
    0 4px 18px rgba(15, 23, 42, 0.04),
    0 1px 3px rgba(15, 23, 42, 0.05);

  display: flex;
  flex-direction: column;

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    border-color: rgba(255, 145, 77, 0.28);

    box-shadow:
      0 12px 28px rgba(15, 23, 42, 0.08),
      0 2px 5px rgba(15, 23, 42, 0.06);
  }
`;

export const RecommendedImageWrap = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  min-height: 140px;
  background: var(--grey1);
  overflow: hidden;
  display: flex;
  align-items: stretch;
  justify-content: stretch;

  img {
    width: 100% !important;
    height: 100% !important;
    min-height: 140px;
    min-width: 100%;
    max-width: 100%;
    max-height: 100%;
    display: block;
    object-fit: cover;
    margin: 0 auto;
    transition: transform 0.25s ease;
    box-sizing: border-box;
  }

  ${EachRecommendedCourse}:hover & img {
    transform: scale(1.04);
  }
`;

export const RecommendedCourseContent = styled.div`
  padding: var(--space-m);

  display: flex;
  flex-direction: column;
  gap: var(--space-xs);

  h5 {
    margin: 0;

    color: var(--grey7);

    font-size: 1.05rem;
    font-weight: 800;
    line-height: 1.3;
  }
`;

export const RecommendedMeta = styled.div`
  span {
    color: var(--grey4);

    font-size: 0.88rem;
    font-weight: 600;
    line-height: 1.4;
  }
`;

export const RecommendedPrice = styled.div`
  margin-top: var(--space-xs);
  color: var(--grey5);
  font-size: 1.1rem;
  font-weight: 800;
`;
